module.exports = __webpack_public_path__ + "img/service_normal.22b2e943.svg";